import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useOrganization } from '../context/OrganizationContext';
import './Navbar.css';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { organization } = useOrganization();
  const { isAuthenticated, isAdmin, logout } = useAuth();
  const navigate = useNavigate();

  const closeMenu = () => setIsMenuOpen(false);

  const handleLogout = async () => {
    await logout();
    navigate('/');
    closeMenu();
  };

  const toggleMenu = () => {
    setIsMenuOpen((open) => !open);
  };

  return (
    <nav className="navbar">
      <div className="container">
        <div className="navbar-content">
          <Link to="/" className="navbar-brand" onClick={closeMenu}>
            {organization?.logo ? (
              <img src={organization.logo} alt={organization.chinese_name || organization.name} className="navbar-logo" />
            ) : (
              <span className="navbar-brand-text">
                {organization?.chinese_name || organization?.english_name || 'Hong Kong Synergies'}
              </span>
            )}
          </Link>

          <button
            type="button"
            className={`navbar-toggle ${isMenuOpen ? 'active' : ''}`}
            onClick={toggleMenu}
            aria-label={isMenuOpen ? '關閉選單' : '開啟選單'}
            aria-expanded={isMenuOpen}
          >
            <span></span>
            <span></span>
            <span></span>
          </button>

          {isMenuOpen && (
            <button
              type="button"
              className="navbar-overlay"
              aria-label="關閉選單"
              onClick={closeMenu}
            />
          )}

          <div className={`navbar-menu ${isMenuOpen ? 'active' : ''}`}>
            <Link to="/" onClick={closeMenu}>首頁</Link>
            <Link to="/about" onClick={closeMenu}>關於我們</Link>
            <Link to="/services" onClick={closeMenu}>核心服務</Link>
            <Link to="/organization-structure" onClick={closeMenu}>組織架構</Link>
            <Link to="/blog" onClick={closeMenu}>最新消息</Link>
            <Link to="/contact" onClick={closeMenu}>聯絡我們</Link>

            {isAuthenticated() ? (
              <>
                {isAdmin() ? (
                  <Link to="/admin" className="btn-nav" onClick={closeMenu}>
                    管理面板
                  </Link>
                ) : (
                  <Link to="/member" className="btn-nav" onClick={closeMenu}>
                    會員專區
                  </Link>
                )}
                <button type="button" onClick={handleLogout} className="btn-nav btn-logout">
                  登出
                </button>
              </>
            ) : (
              <>
                <Link to="/login" className="btn-nav" onClick={closeMenu}>
                  登入
                </Link>
                <Link to="/register" className="btn-nav btn-primary" onClick={closeMenu}>
                  加入會員
                </Link>
              </>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
